import React, { useState, useCallback } from "react";
import {
  useNavigate,
  useRouteLoaderData,
  Link,
  useOutletContext,
} from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import EndCustomerPrintedForm from "Components/Endcustomerprinted/EndCustomerPrintedForm";
import Paper from "Components/UI/Paper";
import usePost2 from "Hooks/usePost";

import { updateEndCustomerPrinted, deleteEndCustomerPrinted } from "API/swesum";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export function EndCustomerPrintedCard() {
  const context = useOutletContext();

  const files = context[0];
  const invoices = context[1];

  const { endcustomerPrinted } = useRouteLoaderData("printed");
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const { openSuccess, openError } = usePopupNotificationContext();

  const [formData, setFormData] = useState({
    SystemStatus: endcustomerPrinted.SystemStatus,
    ParseStatus: endcustomerPrinted.ParseStatus,
    ParseMessage: endcustomerPrinted.ParseMessage,
    Id: endcustomerPrinted.Id,
    Amount: endcustomerPrinted.Amount ? endcustomerPrinted.Amount : 0,
    InvoiceId: endcustomerPrinted.InvoiceId,
    FileId: endcustomerPrinted.FileId,
    CreateTime: endcustomerPrinted.CreateTime,
    OCR: endcustomerPrinted.OCR,
    LastPayment: endcustomerPrinted.LastPayment,
    Status: endcustomerPrinted.Status,
    EndCustomerName: endcustomerPrinted.EndCustomerName
      ? endcustomerPrinted.EndCustomerName
      : "",
  });

  const updateInvoiceReq = usePost2({
    mtnFunc: (body) => {
      return updateEndCustomerPrinted(endcustomerPrinted.Id, body);
    },
    onSuccess: () => {
      openSuccess("Sparat", 3000);
    },
    onError: () => {
      openError("Ett fel har uppstått vid uppdatering av fakturan", 2000);
    },
  });
  const deleteInvoiceReq = usePost2({
    mtnFunc: () => deleteEndCustomerPrinted(endcustomerPrinted.Id),
    onError: () => {
      closeDialog();
      openError("Ett fel uppstod när fakturan sparades");
    },
    onSuccess: () => {
      closeDialog();
      navigate("/endcustomerprinted");
    },
  });

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  const updateInvoicee = () => {
    updateInvoiceReq.post(formData);
  };

  const closeDialog = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Grid container rowSpacing={10} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid item xs={12} md={12}>
          <Paper>
            <Typography
              sx={{ marginBottom: "1.0rem" }}
              variant="h5"
              align="left"
            >
              Fakturautskriftskort
            </Typography>
            {formData && (
              <EndCustomerPrintedForm
                formData={formData}
                endcustomerPrinted={endcustomerPrinted}
                handleInputChange={handleInputChange}
                files={files}
                invoices={invoices}
              />
            )}
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button onClick={() => navigate(-1)} sx={{ ml: 1 }}>
                Stäng
              </Button>
              <Button
                onClick={updateInvoicee}
                variant="contained"
                sx={{ ml: 3 }}
              >
                Spara
              </Button>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>{"Ta bort faktura"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              "Fakturan kommer att tas bort från systemet. Åtgärden går inte att ångra."
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Stäng</Button>
          <Button
            color="error"
            onClick={() => deleteInvoiceReq.post()}
            autoFocus
          >
            Ta bort
          </Button>
        </DialogActions>
      </Dialog>
      {updateInvoiceReq.loading && <Typography>{"Laddar"}</Typography>}
      {updateInvoiceReq.error && (
        <Typography color={"error"}>
          {JSON.stringify(updateInvoiceReq.error.response?.details)}
        </Typography>
      )}
    </>
  );
}
